<opac-user-title
  [title]="'user.suggestions.title.default' | translateByCustomerType: customerType.dbValue"
  [skeleton]="isLoading"></opac-user-title>

<div class="user-area-wrapper">
  <div *ngIf="!isLoading" class="user-suggestions" [attr.dir]="textDirection">
    <opac-button *ngIf="userService.purchaseSuggestions.length" (click)="openSuggestionsDialog()">
      <opac-icon slot="start" icon="add"></opac-icon>
      {{ 'user.suggestions.add' | translate }}
    </opac-button>

    <opac-no-results
      *ngIf="!userService.purchaseSuggestions.length"
      [label]="'user.suggestions.noSuggestions' | translateByCustomerType: customerType.dbValue">
      <opac-no-results-cta>
        <ng-container slot="label"
          >{{ 'user.suggestions.suggestTitle.default' | translateByCustomerType: customerType.dbValue }}</ng-container
        >
        <opac-button (click)="openSuggestionsDialog()">
          <opac-icon slot="start" icon="add"></opac-icon>
          {{ 'user.suggestions.add' | translate }}
        </opac-button>
      </opac-no-results-cta>
    </opac-no-results>

    <div class="user-suggestions__list">
      <app-record-card-grid>
        <app-user-suggestions-item
          *ngFor="let suggestion of userService.purchaseSuggestions"
          [suggestionItem]="suggestion"></app-user-suggestions-item>
      </app-record-card-grid>
    </div>
  </div>
</div>

<ng-container *ngIf="isLoading">
  <app-record-card-grid>
    <ng-container *ngFor="let i of [1, 2, 3, 4]; let last = last; let first = first">
      <card-item-skeleton></card-item-skeleton>
      <opac-skeleton *ngIf="!last" class="hide-tablet" style="height: 1px; margin: 0 -16px"></opac-skeleton>
    </ng-container>
    <opac-degrade></opac-degrade>
  </app-record-card-grid>
</ng-container>
